<app-header></app-header>





<form *ngIf="cancelForm" [formGroup]="cancelForm" class="online-cancellation">
  <mat-horizontal-stepper [linear]="true" #stepper>
    <mat-step formGroupName="token" [stepControl]="tokenForm" [editable]="!cancelForm.disabled">
      <ng-template matStepLabel>{{"ORDER_CANCELLATION.TOKEN.LABEL" | translate}}</ng-template>
      <mat-card class="step-card">
        <mat-card-header>
          <mat-card-title>{{"ORDER_CANCELLATION.TOKEN.TITLE" | translate}}</mat-card-title>
          <mat-card-subtitle>{{"ORDER_CANCELLATION.TOKEN.SUBTITLE" | translate}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <mat-form-field>
            <input matInput
                   [placeholder]="'ORDER_CANCELLATION.TOKEN.FORM.TOKEN' | translate"
                   formControlName="token"
                   minlength="9"
                   maxlength="9"
                   pattern="^(\d{9}|CP\d{7})$">
          </mat-form-field>





        </mat-card-content>
        <mat-card-actions align="end">
          <div fxFlex></div>

          <button mat-raised-button color="primary" [disabled]="tokenForm.invalid" type="button"
            (click)="sendToken(tokenForm.value)">{{"BUTTON.NEXT" | translate}}</button>
        </mat-card-actions>
      </mat-card>
    </mat-step>
    <mat-step formGroupName="sms" [stepControl]="smsForm" [editable]="!cancelForm.disabled">
      <ng-template matStepLabel>{{"ORDER_CANCELLATION.PHONE.LABEL" | translate}}</ng-template>


      <div [hidden]="changePhoneVisible">
        <mat-card class="step-card" >
        <mat-card-header>
          <mat-card-title>{{"ORDER_CANCELLATION.PHONE.TITLE" | translate}}</mat-card-title>
          <mat-card-subtitle *ngIf="phone"><div [innerHTML]="'ORDER_CANCELLATION.PHONE.SUBTITLE' | translate: {value: phone}"></div>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>

          <mat-form-field>
            <input matInput [placeholder]="'ORDER_CANCELLATION.PHONE.FORM.CODE' | translate" formControlName="code"
              maxlength="6" pattern="[a-zA-Z0-9]*">
          </mat-form-field>
          <br />

          <button mat-raised-button type="button" color="primary" [disabled]="ticks > 0"
                  (click)="sendPhoneCode()">{{"ORDER_CANCELLATION.PHONE.FORM.SEND" | translate}} {{ getTick() }}</button>
          <br /><br /><br />
        </mat-card-content>
        <mat-card-actions align="end">
          <button mat-raised-button matStepperPrevious type="button">{{"BUTTON.PREVIOUS" | translate}}</button>
          <button mat-raised-button type="button" style="margin-left: 30px;" color="primary"
                  (click)="changePhoneNr()">{{"ORDER_CANCELLATION.PHONE.FORM.CHANGE" | translate}}</button>
          <div fxFlex></div>


          <!--<button mat-raised-button type="button"
            (click)="sendPhoneCode()">{{"ORDER_CANCELLATION.PHONE.FORM.RESEND" | translate}}</button>-->
          <button mat-raised-button [disabled]="smsForm.invalid" color="primary" type="button"
            (click)="verifyPhoneCode(smsForm.value)">{{"BUTTON.NEXT" | translate}}</button>
        </mat-card-actions>
      </mat-card>
      </div>

      <div [hidden]="!changePhoneVisible">
        <form *ngIf="changePhoneForm" [formGroup]="changePhoneForm" (ngSubmit)="onChangePhoneSubmit()" class="content-card">
          <mat-card >
            <mat-card-header>
              <mat-card-title>{{"ORDER_CANCELLATION.PHONE.FORM_CHANGE.TITLE" | translate}}</mat-card-title>
            </mat-card-header>
            <mat-card-content>


              <div style="width: 200px;">
                <app-date-edit  [placeholder]="'ORDER_CANCELLATION.PHONE.FORM_CHANGE.DOB' | translate" formControlName="dob" required
                             [max]="maxDob" [min]="minDob"></app-date-edit>
              </div>
                <br >
                <label style="margin-bottom: 3px;">{{"ORDER_CANCELLATION.PHONE.FORM.ENTER_PHONE" | translate}}</label><br />
              <div style="width: 200px;">
                <mat-form-field>
                  <input matInput [placeholder]="'ORDER_CANCELLATION.PHONE.FORM_CHANGE.NR' | translate" formControlName="phone" [imask]="phoneMask" [unmask]="true" minlength="10"
                       maxlength="15" required>
                </mat-form-field>
              </div>


            </mat-card-content>
            <mat-card-actions align="start">


              <button mat-raised-button type="button" color="default" [disabled]="false" (click)="changePhoneNr()" >
                {{ 'ORDER_CANCELLATION.PHONE.FORM_CHANGE.BACK' | translate }}
              </button>
              <button mat-raised-button type="button" color="primary" (click)="onChangePhoneSubmit()" [disabled]="!changePhoneForm.valid">
                {{ 'ORDER_CANCELLATION.PHONE.FORM_CHANGE.SAVE' | translate }}
              </button>

            </mat-card-actions>
          </mat-card>
        </form>
      </div>






    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{"ORDER_CANCELLATION.DETAILS.LABEL" | translate}}</ng-template>
      <mat-card class="step-card">
        <mat-card-header>
          <mat-card-title>{{"ORDER_CANCELLATION.DETAILS.TITLE" | translate}}</mat-card-title>
          <mat-card-subtitle>{{"ORDER_CANCELLATION.DETAILS.SUBTITLE" | translate}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content *ngIf="orderDetails">
          <p>{{"ORDER_CANCELLATION.DETAILS.FORM.TITLE" | translate}}: <mat-label>{{orderDetails.title}}</mat-label>
          </p>
          <p>{{"ORDER_CANCELLATION.DETAILS.FORM.FIRST_NAME" | translate}}: <mat-label>{{orderDetails.firstName}}
            </mat-label>
          </p>
          <p>{{"ORDER_CANCELLATION.DETAILS.FORM.LAST_NAME" | translate}}: <mat-label>{{orderDetails.lastName}}
            </mat-label>
          </p>
          <p>{{"ORDER_CANCELLATION.DETAILS.FORM.PRODUCT_NAME" | translate}}: <mat-label>{{orderDetails.productName}}
            </mat-label>
          </p>
        </mat-card-content>
        <mat-card-actions align="end">
          <button mat-raised-button matStepperPrevious type="button">{{"BUTTON.PREVIOUS" | translate}}</button>
          <div fxFlex></div>
          <button matStepperNext mat-raised-button color="primary" type="button">{{"BUTTON.NEXT" | translate}}</button>
        </mat-card-actions>
      </mat-card>
    </mat-step>
    <mat-step formGroupName="reason" [stepControl]="reasonForm" [editable]="!cancelForm.disabled">
      <ng-template matStepLabel>{{"ORDER_CANCELLATION.REASON.LABEL" | translate}}</ng-template>
      <mat-card class="step-card">
        <mat-card-header>
          <mat-card-title>{{"ORDER_CANCELLATION.REASON.TITLE" | translate}}</mat-card-title>
          <mat-card-subtitle>{{"ORDER_CANCELLATION.REASON.SUBTITLE" | translate}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>

          <mat-form-field style="margin-top: 20px;width: 300px;">
            <mat-label>{{"ORDER_CANCELLATION.REASON.FORM.REASON" | translate}}</mat-label>
            <mat-select formControlName="userCancellationReason" (selectionChange)="onUserCancellationReasonChanged()">
              <mat-option [value]="1">
                {{"ORDER_CANCELLATION.REASONS.1" | translate}}
              </mat-option>
              <mat-option [value]="2">
                {{"ORDER_CANCELLATION.REASONS.2" | translate}}
              </mat-option>
              <mat-option [value]="3">
                {{"ORDER_CANCELLATION.REASONS.3" | translate}}
              </mat-option>
              <mat-option [value]="4">
                {{"ORDER_CANCELLATION.REASONS.4" | translate}}
              </mat-option>
              <mat-option [value]="5">
                {{"ORDER_CANCELLATION.REASONS.5" | translate}}
              </mat-option>
              <mat-option [value]="6">
                {{"ORDER_CANCELLATION.REASONS.6" | translate}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div [hidden]="!showUserCancellationReasonCustom">
            <mat-form-field class="cancellation-reason">
              <input matInput [placeholder]="'ORDER_CANCELLATION.REASON.FORM.CUSTOM_INPUT' | translate" formControlName="reason"
                     maxlength="250">
            </mat-form-field>
          </div>

        </mat-card-content>
        <mat-card-actions align="end">
          <button mat-raised-button matStepperPrevious type="button">{{"BUTTON.PREVIOUS" | translate}}</button>
          <div fxFlex></div>
          <button mat-raised-button matStepperNext color="primary" type="button">{{"BUTTON.NEXT" | translate}}</button>
        </mat-card-actions>
      </mat-card>
    </mat-step>
    <mat-step >
      <ng-template matStepLabel>{{"ORDER_CANCELLATION.OUTSTANDING.LABEL" | translate}}</ng-template>
      <mat-card class="step-card">
        <mat-card-header>
          <mat-card-title>{{"ORDER_CANCELLATION.OUTSTANDING.TITLE" | translate}}</mat-card-title>
          <mat-card-subtitle>{{"ORDER_CANCELLATION.OUTSTANDING.SUBTITLE" | translate}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content *ngIf="orderDetails">
          <p>{{"ORDER_CANCELLATION.DETAILS.FORM.OUTSTANDING" | translate}}: <mat-label> {{orderDetails.outstandingAmount}}</mat-label>
            <br /><br />
          </p>
          <br />
          <hr />
          <p [innerHTML]="'ORDER_CANCELLATION.OUTSTANDING.INFO_FEE' | translate: {value: maskedEmail}"></p>


          <form *ngIf="changeEmailForm" [formGroup]="changeEmailForm" (ngSubmit)="doRequestChangeEmailAndSubmitCancellationDetails(reasonForm.value)" class="content-card">
            <div [hidden]="!newEmailVisible" >

              <mat-card style="margin-top: 25px;">
            <mat-card-header>
              <mat-card-title class="mat-h2">{{"ORDER_CANCELLATION.EMAIL.FORM_CHANGE.TITLE" | translate}}</mat-card-title>
            </mat-card-header>
            <mat-card-content>


              <mat-form-field style="width: 350px;">
                <input matInput placeholder="{{'ORDER_CANCELLATION.EMAIL.FORM_CHANGE.ENTER_NEW_EMAIL' | translate}}"
                       type="email" formControlName="email"
                       minlength="6" pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z0-9 .-]{2,}[.]{1}[a-zA-Z]{2,}"
                       [disabled]="!newEmailVisible"
                        required>

              </mat-form-field>

              <div style="width: 350px;">
                <app-date-edit required class="date-field" placeholder="{{'ORDER_CANCELLATION.EMAIL.FORM_CHANGE.DOB' | translate}}"
                             formControlName="dob" #datefield></app-date-edit>
              </div>


              <br /><br />
              <mat-error *ngIf="showErrorChangeMail">
                {{ errorMessageChangeMail }}
              </mat-error>

            </mat-card-content>
            <mat-card-actions align="end">
              <button mat-raised-button type="button" color="default" [disabled]="disableChangeEmailControls" (click)="doBackFromChangeEmail()">
                {{'ORDER_CANCELLATION.EMAIL.FORM_CHANGE.BACK' | translate}}
              </button>
              <button mat-raised-button type="button" color="primary" [disabled]="(!changeEmailForm.valid || disableChangeEmailControls) " (click)="doRequestChangeEmailAndSubmitCancellationDetails(reasonForm.value)">
                {{'ORDER_CANCELLATION.EMAIL.FORM_CHANGE.SAVE' | translate}}
              </button>



            </mat-card-actions>
          </mat-card>

          </div>
          </form>

          <mat-card-actions align="start">
            <div *ngIf="!newEmailVisible">
              <button mat-raised-button type="button" style="margin-left: 30px;" color="primary"
                      (click)="showChangeEmailForm()">{{"ORDER_CANCELLATION.EMAIL.CHANGE" | translate}}
              </button>
            </div>
          </mat-card-actions>

        </mat-card-content>
        <mat-card-actions align="end" >
          <div *ngIf="!newEmailVisible">
            <button mat-raised-button matStepperPrevious type="button">{{"BUTTON.PREVIOUS" | translate}}</button>
            <div fxFlex></div>
            <button mat-raised-button color="primary" type="button"
              (click)="submitCancellationDetails(reasonForm.value)">{{"BUTTON.NEXT" | translate}}</button>
          </div>
        </mat-card-actions>
      </mat-card>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{"ORDER_CANCELLATION.EMAIL_CONFIRMATION.LABEL" | translate}}</ng-template>
      <mat-card class="step-card">
        <mat-card-header>
          <mat-card-title>{{"ORDER_CANCELLATION.EMAIL_CONFIRMATION.TITLE" | translate}}</mat-card-title>
          <mat-card-subtitle>{{"ORDER_CANCELLATION.EMAIL_CONFIRMATION.SUBTITLE" | translate}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p [innerHTML]="'ORDER_CANCELLATION.EMAIL_CONFIRMATION.DESCRIPTION_WITH_EMAIL' | translate: {value: maskedEmail}"></p>



        </mat-card-content>

      </mat-card>
    </mat-step>
  </mat-horizontal-stepper>
</form>
